import { ActivityItem } from "services/api/platform/types";
import { Badge } from "ui/components/Badge";
import UserCell from "ui/components/Table/TableSearch/components/Cells/UserCell";
import { Column, ColumnTypes } from "ui/components/Table/TableSearch/types";

const TYPE_VARIANT: Record<string, "success" | "info" | "danger" | "secondary"> = {
  Create: "success",
  Update: "info",
  Delete: "danger",
};

const formatMoment = (iso: string): string => {
  const date = new Date(iso);

  return `${date.toLocaleDateString("hr-HR")} ${date.toLocaleTimeString("hr-HR", {
    hour: "2-digit",
    minute: "2-digit",
  })}`;
};

/**
 * Stupci primaju imena klijenata jer zapis nosi samo `tenantId`.
 *
 * Ime se ne dohvaća po retku — popis klijenata je ionako već učitan na nadzornoj ploči.
 */
export const ACTIVITY_COLUMNS = (tenantNames: Map<string, string>): Column[] => [
  {
    title: "Vrsta",
    field: "type",
    sortable: true,
    type: ColumnTypes.custom,
    render: (row: ActivityItem) => (
      <Badge
        text={row.type}
        variant={TYPE_VARIANT[row.type] ?? "secondary"}
        height="small"
      />
    ),
  },
  {
    title: "Aktivnost",
    field: "comment",
    sortable: true,
    type: ColumnTypes.custom,
    render: (row: ActivityItem) => (
      <div className="min-w-[200px] whitespace-normal">
        <p className="text-slate-700">{row.comment}</p>
        <p className="text-xs text-slate-400">
          {tenantNames.get(row.tenantId) ?? row.tenantId}
          {row.entityName ? ` · ${row.entityName}` : ""}
        </p>
      </div>
    ),
  },
  {
    title: "Korisnik",
    field: "userFullName",
    sortable: true,
    type: ColumnTypes.custom,
    render: (row: ActivityItem) => (
      <UserCell fullName={row.userFullName} userId={row.userId} />
    ),
  },
  {
    title: "Vrijeme",
    field: "created",
    sortable: true,
    type: ColumnTypes.custom,
    render: (row: ActivityItem) => (
      <span className="text-xs text-slate-400 whitespace-nowrap">
        {formatMoment(row.created)}
      </span>
    ),
  },
];
